/**
 * Types
 */

export const Types = {
  SET_PAYMENT_VALUE: "payment/SET_PAYMENT_VALUE",
}
